import { render } from "./DemoConfigStruct.vue?vue&type=template&id=8716cf86&scoped=true"
import script from "./DemoConfigStruct.vue?vue&type=script&lang=js"
export * from "./DemoConfigStruct.vue?vue&type=script&lang=js"

import "./DemoConfigStruct.vue?vue&type=style&index=0&id=8716cf86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8716cf86"]])

export default __exports__